module.exports = __webpack_public_path__ + "static/OurVolunteers-5f7fcc3e6e5ddf6d9baf4a16721ea1ee.jpg";